import { PaymentMethod } from '../stores/usePaymentMethodsStore';
import { formatPaymentMethodDisplayFields } from './paymentMethodMedia';

/**
 * Formatea métodos de pago en texto legible para WhatsApp/Email
 */
export const formatPaymentMethods = (methods: PaymentMethod[]): string => {
  if (methods.length === 0) return '';

  const formattedMethods = methods.map((method) => {
    const icon = method.icon || '💳';
    const fields = formatPaymentMethodDisplayFields(
      (method.account_info || {}) as Record<string, unknown>
    );
    const extra = [method.description, fields].filter(Boolean).join('\n');
    return `${icon} ${method.method_name}${extra ? `\n${extra}` : ''}`;
  });

  return `\n\n💳 *Métodos de Pago:*\n\n${formattedMethods.join('\n\n')}`;
};

/**
 * Formatea métodos de pago en formato más compacto para emails
 */
export const formatPaymentMethodsEmail = (methods: PaymentMethod[]): string => {
  if (methods.length === 0) return '';

  const formattedMethods = methods.map((method) => {
    const icon = method.icon || '💳';
    const fields = formatPaymentMethodDisplayFields(
      (method.account_info || {}) as Record<string, unknown>
    ).replace(/\n/g, ' · ');
    const extra = [method.description?.trim(), fields].filter(Boolean).join(' · ');
    return `${icon} ${method.method_name}${extra ? `: ${extra}` : ''}`;
  });

  return `\n\nMétodos de Pago:\n${formattedMethods.join('\n')}`;
};


